import { useEffect, useState } from "react";
import { Card } from "./../../components/card/card.jsx";
import { Link } from "react-router-dom";
import { dataTrainningAll } from "../../config/apiSPA.js";
import Pagination2 from "../../components/pagination/pagination2.jsx";
import SpinnerTable from "../../components/spinner/spinnerTable.jsx";
import DateFormat from "../../components/dateFormater/dateFormat1.js";
import Pagination3 from "../../components/pagination/pagination3.jsx";

const trainingPresetData = {
  data: [],
  links: null,
  meta: null,
};

function DataTraining() {
  const [trainingAll, setTrainingAll] = useState(trainingPresetData);
  const [search1Value, setSearch1Value] = useState("");
  const [loadingTable, setLoadingTable] = useState(true);
  function nextClick1() {
    loadData(search1Value, trainingAll.meta.current_page + 1);
  }
  function prevClick1() {
    loadData(search1Value, trainingAll.meta.current_page - 1);
  }
  function submitSearch1(e) {
    e.preventDefault();
    loadData(search1Value, "");
  }

  const loadData = async (search = "", page = "") => {
    try {
      setLoadingTable(true);
      const res = await dataTrainningAll(search, page);
      setTrainingAll(res);
      setLoadingTable(false);
    } catch (error) {
      setLoadingTable(true);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <div>
        <ul className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#/">TRAINING</a>
          </li>
          <li className="breadcrumb-item active">Data</li>
        </ul>

        <h1 className="page-header">
          Training Records <small></small>
        </h1>

        <hr className="mb-4" />

        <Card>
          <div className="tab-content p-4">
            {/* ----------------All Tab------------------------------------------------------------------ */}
            <div className="tab-pane fade show active" id="allTab">
              <form onSubmit={(e) => submitSearch1(e)}>
                <div className="input-group mb-4">
                  <div className="d-flex justify-content-end">
                    <div className="input-group">
                      <input type="text" onChange={(e) => setSearch1Value(e.target.value)} className="form-control px-35px" placeholder="coba cari : meli" />
                      <div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0" style={{ zIndex: 1020 }}>
                        <i className="fa fa-search opacity-5"></i>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-outline-default" type="submit">
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </form>

              {/* ----------------Table-------------- */}

              <div className="table-responsive">
                <table className="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th></th>
                      <th className="border-top-0 pt-0 pb-2">Training Title</th>
                      <th className="border-top-0 pt-0 pb-2">Location</th>
                      <th className="border-top-0 pt-0 pb-2">Institution</th>
                      <th className="border-top-0 pt-0 pb-2">Instructor</th>
                      <th className="border-top-0 pt-0 pb-2">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingTable ? (
                      <SpinnerTable colSpan={6} />
                    ) : trainingAll.data.length > 0 ? (
                      trainingAll.data.map((value, index) => (
                        <tr key={index}>
                          <td className="align-left d-inilne-flex align-items-center">
                            <span className="d-inline-flex justify-content-center align-items-center" style={{ minWidth: "20px" }}>
                              {value.atmp === 1 && <i className="text-danger fab fa-angular" title="This training is based on ATMP"></i>}
                            </span>
                            <span className="d-inline-flex justify-content-center align-items-center" style={{ minWidth: "20px" }}>
                              {value.kpi === 1 && <i className="text-info fas fa-chart-pie" title="This training is counted as a KPI"></i>}
                            </span>
                          </td>
                          <td className="align-middle">
                            <Link to={"/training/detail/" + value.id}>{value.trainingCode.title}</Link>
                          </td>
                          <td className="align-middle">{value.locationData.location}</td>
                          <td className="align-middle">{value.institutionData.institutionName}</td>
                          <td className="align-middle">{value.instructorData.namaInstructor}</td>
                          <td className="align-middle">{DateFormat(value.startDate)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="align-middle">
                          no Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* ----------------End Table-------------- */}

              {!loadingTable && trainingAll.data.length > 0 ? <Pagination3 pageInfo={trainingAll} nextClick={nextClick1} prevClick={prevClick1} /> : ""}
            </div>
            {/* ----------------End All Tab------------------------------------------------------------------ */}
          </div>
        </Card>
      </div>
    </>
  );
}

export default DataTraining;
